import { Guid } from './types'

export type CanDoResultDto = {
    id: Guid
    score: number | null
}

export type ClassResultPayload = {
    studentId: Guid
    resultType: number | null
    comment: string
    canDoResults: CanDoResultDto[]
}

export type StudentResultInput = {
    userId: Guid
    comment: string
    contentItemResultType?: number | undefined
    scores: Map<Guid, number>
}

/**
 * Adapts a student's in-memory assessment state into the DTO expected by
 * /bookapi/api/class/:classId/result.
 *
 * @param student - The student state to transform.
 * @param isFinal - When true, the student's contentItemResultType is sent as
 *                  resultType; otherwise resultType is null for partial saves.
 */
export const adaptStudentResult = (student: StudentResultInput, isFinal: boolean = false): ClassResultPayload => ({
    studentId: student.userId,
    resultType: isFinal ? (student.contentItemResultType ?? null) : null,
    comment: student.comment ?? '',
    canDoResults: Array.from(student.scores.entries()).map(([id, score]) => ({ id, score: score === 0 ? null : score }))
})
